(function($) {
    var w4d = window.w4d || {};

    w4d.select = {

        checkSelectedTimeout: null,

        init: function () {
            // console.time('INIT_SELECT');
            this.initialize_select();
            this.initialize_filters_toggle();
            this.initialize_reset_all_button();
            this.initializeFiltersFromURL();
            W4D_FrontendHelper.checkFilterOverflow();
            $('.filter.visibility-hidden').removeClass('visibility-hidden');
            // console.timeEnd('INIT_SELECT');
        },

        /**
         * check_selected_filters - Check and log if any of the filters are selected
         *
         * @return {Undefined}
         */
        check_selected_filters: function() {
            let anySelected = false;

            $('.js-basic-single, .js-basic-multiple').each(function() {
                let $select = $(this);

                // Skip the Sort filter
                if ($select.data('custom-name') === 'Sortiranje')
                    return true;

                // Check if the element has been initialized with Select2
                if ($select.hasClass("select2-hidden-accessible")) {
                    try {
                        let data = $select.select2('data');
                        if (data && data.length > 0) {
                            anySelected = true;
                        }
                    } catch (error) {
                        console.warn("Error accessing Select2 data:", error);
                    }
                }
            });

            // Check range filters
            if (W4D_RangeFilter && W4D_RangeFilter.$rangeFilters) {
                W4D_RangeFilter.$rangeFilters.each(function() {
                    const filter = $(this);
                    const rangeInputs = {
                        min: filter.find(".js-min-range"),
                        max: filter.find(".js-max-range")
                    };
                    const defaultMax = parseInt(rangeInputs.max.attr('max'), 10) || 10000;
                    const defaultMin = parseInt(rangeInputs.min.attr('min'), 10) || 0;

                    if (rangeInputs.min && rangeInputs.max) {
                        const minVal = parseInt(rangeInputs.min.val(), 10) || 0;
                        const maxVal = parseInt(rangeInputs.max.val(), 10) || defaultMax;

                        // Check if min value is not 0 or max value is not equal to default max value
                        if (minVal > defaultMin || maxVal < defaultMax) {
                            anySelected = true;
                        }
                    }
                });
            }

            // Show or hide the reset-all button based on whether any filters are selecteds
            if (anySelected) {
                $('.js-reset-all').addClass('show');
            } else {
                $('.js-reset-all').removeClass('show');
            }

            return anySelected;
        },

        /**
         * Initialize click event for .js-reset-all button
         *
         * @return {Undefined}
         */
        initialize_reset_all_button: function() {
            let self = this;
            $('.js-reset-all').on('click', function() {
                self.reset_all_filters();
            });
        },

        /**
         * reset_all_filters - Resets all filters and hides the reset-all button
         *
         * @return {Undefined}
         */
        reset_all_filters: function() {
            // Loop through all single and multiple select2 filters and reset them
            $('.js-basic-single, .js-basic-multiple').each(function() {
                let $select = $(this);

                // Reset the selection and trigger the change event
                $select.val(null).trigger('change');
                $select.next().removeClass('has-selection');
            });

            // Reset range filters
            if (W4D_RangeFilter && W4D_RangeFilter.$rangeFilters) {
                W4D_RangeFilter.resetFilter();
            }

            // Hide the reset-all button after resetting all filters
            $('.js-reset-all').removeClass('show');

            this.w4d_clear_url_params();
        },

        w4d_clear_url_params: function() {
            let currentUrl = window.location.href.split('?')[0]; // Get the base
            window.history.pushState({}, document.title, currentUrl);
            W4D_Pagination.fetchProducts();
        },

        /**
         * handle_window_resize - Remove 'open' class from filters on window resize
         *
         * @return {undefined}
         */
        handle_window_resize: function() {
            window.addEventListener('resize', function() {
                document.querySelectorAll('.filters.open').forEach(filter => {
                    filter.classList.remove('open');

                    // Reset overflow when filters are closed on resize
                    document.body.style.overflow = '';
                });
            });
        },

        /**
         * initialize_filters_toggle - Set up click event listeners for filter toggle buttons
         *
         * @return {undefined}
         */
        initialize_filters_toggle: function() {
            var self = this;

            document.querySelectorAll('.js-filters-toggle').forEach(toggle => {
                toggle.addEventListener('click', function() {
                    const filtersContainer = toggle.closest('.filters');
                    if (filtersContainer) {
                        filtersContainer.classList.toggle('open');
                        self.update_body_overflow();
                    }
                });
            });
        },

        /**
         * update_body_overflow - Toggle overflow hidden on body based on filter state
         *
         * @return {undefined}
         */
        update_body_overflow: function() {
            if (document.querySelector('.filters.open')) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },

        /**
         * initialize_select - Initialize Select2 and related functionality for multiple selects
         *
         * @return {Undefined}
         */
        initialize_select: function () {
            var self = this;

            $('.js-basic-single').each(function() {
                var $select = $(this);

                // Check if the select element is not multiple
                if (!$select.attr('multiple')) {
                    $select.closest('.filter').addClass('filter--single');
                }

                $select.select2({
                    placeholder: 'Sortiranje',
                    closeOnSelect: false,
                    templateResult: self.format_state,
                    templateSelection: function (state) {
                        if ($select.attr('title') === 'Sortiranje') {
                            // Update the title attribute of the selection element
                            setTimeout(() => {
                                $select.next('.select2-container')
                                    .find('.select2-selection')
                                    .attr('title', state.text);
                            }, 0);
                            return;
                        }
                        return state.text;
                    },
                    allowHtml: true,
                    allowClear: false,
                    tags: false,
                    dropdownParent: $select.closest('.filter'),
                });

                self.add_custom_name_to_container($select);

                $select.val(null).trigger('change');

                $select.on('select2:open', function() {
                    setTimeout(function() {
                        const dropdown = $('.select2-dropdown');
                        const dropdownRect = dropdown[0]?.getBoundingClientRect();
                        const wrapperRect = $('.filters__wrapper')[0]?.getBoundingClientRect();

                        if(dropdownRect && wrapperRect){
                            if (dropdownRect.right > wrapperRect.right) {
                                const overflow = dropdownRect.right - wrapperRect.right;
                                dropdown.parent().css('left', `-${overflow}px`);
                            }
                        }
                    }, 0);
                    $('.select2-search__field').attr('placeholder', 'Unesite pojam');
                });

                // Handle 'select' and 'unselect' events to update the checkboxes and toggle class
                $select.on('select2:select select2:unselect', function(e) {
                    // Debounce the check_selected_filters call
                    clearTimeout(self.checkSelectedTimeout);
                    self.checkSelectedTimeout = setTimeout(() => {
                        self.toggle_has_selection($select);
                        self.check_selected_filters();
                        const selectedFilter = $(this).val();
                        const taxonomy_name = $(this).data('custom-taxonomy');
                        if ($select.attr('title') === 'Sortiranje') {
                            $select.select2('close');
                        }
                        self.updateURLWithFilterParams(selectedFilter, taxonomy_name);
                    }, 100);
                });

                // Initialize custom search and button when dropdown is opened
                $select.on('select2:open', function() {
                    setTimeout(function() {
                        self.add_reset_button($select);
                    }, 0);

                    $('.select2-search__field').attr('placeholder', 'Unesite pojam');
                });
            })

            // Initialize Select2 with custom templateResult and templateSelection for all selects
            $('.js-basic-multiple').each(function() {
                var $select = $(this);
                $select.select2({
                    placeholder: 'Select options',
                    closeOnSelect: false,
                    templateResult: self.format_state,
                    templateSelection: function (state) {
                        return self.format_selection($select);
                    },
                    allowHtml: true,
                    allowClear: false,
                    tags: false,
                    dropdownParent: $select.closest('.filter')
                });

                self.add_custom_name_to_container($select);

                // Handle 'select' and 'unselect' events to update the checkboxes and toggle class
                $select.on('select2:select select2:unselect', function(e) {
                    // Debounce the check_selected_filters call
                    clearTimeout(self.checkSelectedTimeout);
                    self.checkSelectedTimeout = setTimeout(() => {
                        self.toggle_has_selection($select);
                        self.check_selected_filters();
                        const selectedFilters = $(this).val();
                        const taxonomy_name = $(this).data('custom-taxonomy');

                        // Close only if it's the sort filter
                        if (taxonomy_name === 'Sortiranje') {
                            $select.select2('close');
                        }

                        self.updateURLWithFilterParams(selectedFilters, taxonomy_name);
                    }, 100);
                });

                // Initialize custom search and button when dropdown is opened
                $select.on('select2:open', function() {
                    setTimeout(function() {
                        const dropdown = $('.select2-dropdown');
                        const dropdownRect = dropdown[0].getBoundingClientRect();
                        const wrapperRect = $('.filters__wrapper')[0].getBoundingClientRect();

                        if (dropdownRect.right > wrapperRect.right) {
                            const overflow = dropdownRect.right - wrapperRect.right;
                            dropdown.parent().css('left', `-${overflow}px`);
                        }
                    }, 0);
                    self.add_reset_button($select);
                    self.add_custom_search($select);
                });

                // Clear the custom search input when the dropdown is closed
                $select.on('select2:close', function() {
                    self.clear_custom_search($select);
                });
            });
        },

        updateURLWithFilterParams: function(filters, taxonomy) {
            const url = new URL(window.location.href);
            if (Array.isArray(filters)) {
                // Handle multiple filters (e.g., for checkboxes)
                if (filters.length === 0) {
                    url.searchParams.delete(taxonomy);
                } else {
                    url.searchParams.set(taxonomy, filters.join(','));
                }
            } else {
                // Handle single value (e.g., for sorting)
                if (filters === null || filters === '') {
                    url.searchParams.delete(taxonomy);
                } else {
                    url.searchParams.set(taxonomy, filters);
                }
            }
            window.history.pushState({}, '', url.toString());

            const isSearchResult=url.searchParams.has('dgwt_wcas');
            const hasSorting=url.searchParams.has('sort');
            const hasFilters=url.searchParams.has(taxonomy);

            if (isSearchResult && !hasSorting && !hasFilters) return;

            //if (window.location.search.includes('dgwt_wcas=1')) return;

            W4D_Pagination.fetchProducts();
        },

        initializeFiltersFromURL: function() {
            const url = new URL(window.location.href);
            const params = url.searchParams;

            $('.js-basic-single, .js-basic-multiple').each((index, element) => {
                const $select = $(element);
                const taxonomy = $select.data('custom-taxonomy');

                // Check if there's a parameter matching this taxonomy
                if (params.has(taxonomy)) {
                    const filterValues = params.get(taxonomy).split(',');

                    $select.val(filterValues);
                    $select.trigger('change');

                    if ($select.hasClass('select2-hidden-accessible')) {
                        $select.trigger('select2:select');
                    }

                    this.toggle_has_selection($select);
                }
            });
        },

        /**
         * add_custom_name_to_container - Adds title to the Select2 container
         *
         * @param {Object} $select - jQuery object of the select element
         * @return {Undefined}
         */
        add_custom_name_to_container: function($select) {
            var customName = $select.data('custom-name'); // Get the custom name from the data attribute
            var $select2Container = $select.next('.select2-container'); // Get the associated Select2 container

            if (customName) {
                // Add the custom name attribute to the selection container
                //$select2Container.find('.select2-selection').attr('title', customName);
                $select2Container.find('.select2-selection').attr('title', customName);
            }
        },

        /**
         * toggle_has_selection - Toggle the class based on the number of selected options
         *
         * @param {Object} $select - jQuery object of the select element
         * @return {Undefined}
         */
        toggle_has_selection: function ($select) {
            var selectedOptionsCount = $select.select2('data').length;
            var container = $select.next('.select2-container'); // Find the associated container

            if (selectedOptionsCount > 0) {
                container.addClass('has-selection');
            } else {
                container.removeClass('has-selection');
            }
        },

        /**
         * format_state - Format how options are shown in the dropdown
         *
         * @param {Object} state
         *
         * @return {Object}
         */

        format_state: function (state) {
            if (!state.id) {
                return state.text;
            }

            if (state.element && state.element.dataset.quantity === "0") {
                return null;
            }

            var color = state.element.dataset.color,
                image = state.element.dataset.image,
                border = state.element.dataset.border,
                $state;

            if (color || image) {
                let backgroundStyle = '';

                if (image) {
                    backgroundStyle = `background-image: url('data:image/jpeg;base64,${image}'); background-size: cover; background-position: center;`;
                } else if (color) {
                    backgroundStyle = `background-color: ${color};`;
                }

                $state = $(
                `<span class="checkbox-container checkbox-container--color">
                <input type="checkbox" class="select2-checkbox" />
                <div class="checkbox-container__color" style="${backgroundStyle}"></div>
                <div class="checkbox-container__text">
                    ${state.text}
                    ${state.element.dataset.quantity ? `<div class="quantity">${state.element.dataset.quantity}</div>` : ''}
                </div>
            </span>`
                );
            } else {
                $state = $(
                    `<span class="checkbox-container"><input type="checkbox" class="select2-checkbox"/><div class="checkmark"></div><div class="checkbox-container__text">${state.text}${state.element.dataset.quantity ? `<div class="quantity">${state.element.dataset.quantity}</div>` : ''}</div></span>`
                );
            }

            // Handle click event on checkbox to toggle selection
            $state.find('.select2-checkbox').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                $(e.target).closest('.select2').find('select').trigger('change'); // Trigger change event for Select2
            });

            return $state;
        },

        /**
         * format_selection - Format how selected options are shown in the input box
         *
         * @param {Object} $select - jQuery object of the select element
         *
         * @return {String}
         */
        format_selection: function ($select) {
            let selectedItems = $select.select2('data'); // Get all selected items

            // If only one item is selected, show that item
            if (selectedItems.length === 1) {
                return selectedItems[0].text;
            }
            // If multiple items are selected, show the number of selected items
            else if (selectedItems.length > 1) {
                return selectedItems.length;
            }
            // If nothing is selected, show the placeholder
            else {
                return 'Select options'; // Placeholder when nothing is selected
            }
        },

        /**
         * add_custom_search - Append a custom search at the start of the dropdown
         *
         * @param {Object} $select - jQuery object of the select element
         * @return {Undefined}
         */
        add_custom_search: function ($select) {
            let $dropdown = $select.data('select2').$dropdown;
            let $customSearch = $dropdown.find('.custom-search');

            if ($customSearch.length === 0) {
                let $searchContainer = $('<div class="custom-search"></div>');
                let $searchInput = $('<input type="text" class="custom-search-input" placeholder="Unesite pojam"/>');

                // Append search input at the top of the dropdown
                $searchContainer.append($searchInput);
                $dropdown.prepend($searchContainer);

                // Add input event handler for custom search input
                $searchInput.on('input', function() {
                    let searchValue = $(this).val();

                    // Locate the real Select2 search input and update it
                    let $select2SearchField = $select.data('select2').$container.find('.select2-search__field');
                    if ($select2SearchField.length) {
                        $select2SearchField.val(searchValue).trigger('input'); // Trigger input event to update results
                    }
                });
            }
        },

        /**
         * clear_custom_search - Clears the custom search input when the dropdown is closed
         *
         * @param {Object} $select - jQuery object of the select element
         * @return {Undefined}
         */
        clear_custom_search: function($select) {
            var $dropdown = $select.data('select2').$dropdown;
            var $customSearchInput = $dropdown.find('.custom-search-input');

            // Clear the search input if it exists
            if ($customSearchInput.length) {
                $customSearchInput.val('');
            }
        },

        /**
         * add_reset_button - Append a custom button at the end of the dropdown
         *
         * @param {Object} $select - jQuery object of the select element
         * @return {Undefined}
         */
        add_reset_button: function ($select) {
            // Skip if this is the sorting select
            if ($select.attr('title') === 'Sortiranje') {
                $select.data('select2').$dropdown.find('.select2-search--dropdown').css('padding', '0 !important');
                return;
            }

            let self = this;
            let $customButton = $select.data('select2').$dropdown.find('.select2-results__option.reset-button-wrapper');

            if ($customButton.length === 0) {
                let $button = $('<div class="select2-results__option reset-button-wrapper" role="presentation">' +
                    '<button type="button" class="reset-button">Poništi odabir</button>' +
                    '</div>');

                // Append the button at the end of the dropdown results
                $select.data('select2').$dropdown.find('.select2-results').append($button);

                $button.find('.reset-button').on('click', function() {
                    let shouldFetchProducts = self.check_selected_filters();
                    $select.val(null).trigger('change');

                    let taxonomy = $select.data('custom-taxonomy');
                    self.removeParameterFromURL(taxonomy);

                    if (shouldFetchProducts) {
                        W4D_Pagination.fetchProducts();
                    }

                    // Close the dropdown
                    $select.select2('close');

                    let $nextSpan = $select.next('span.select2');
                    self.toggle_has_selection($select);
                    $nextSpan.removeClass('select2-container--focus');
                });
            }
        },

        removeParameterFromURL: function(parameter) {
            let url = new URL(window.location.href);
            url.searchParams.delete(parameter);

            if (parameter === 'price') {
                url.searchParams.delete('min_price');
                url.searchParams.delete('max_price');
            }

            window.history.pushState({}, document.title, url.toString());
        },
    };

    $(document).ready(function () {
        w4d.select.init();
    });

    window.w4d = w4d;
})(jQuery);